import styled from 'styled-components';
import { colors, ApButtonGroup } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid ${colors.grey3};
	padding: 0 32px;
	background-color: ${colors.white};
	z-index: 1;
`;

export const TabsWrapper = styled.div`
	display: flex;
`;

export const ControlsWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
`;

export const ButtonGroup = styled(ApButtonGroup)`
	padding-right: 16px;
`;

export const ControlGroup = styled.div`
	padding-left: 9px;
`;

export const CheckboxLabel = styled.div`
	line-height: 14px;
	font-size: 12px;
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;

export const Title = styled.div`
	color: black;
	font-weight: 500;
	font-size: 19px;
	line-height: 24px;
`;
